/**
 * WordPress dependencies
 */
import { createContext, useContext } from '@wordpress/element';

/**
 * Internal dependencies
 */

export const ItemGroupContext = createContext({
  size: 'medium'
});
ItemGroupContext.displayName = 'ItemGroupContext';
export const useItemGroupContext = () => useContext(ItemGroupContext);